import Vue from 'vue'
import Vuex from 'vuex'

import { authentication } from './authentication.module'
import { registration } from './registration.module'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    authentication,
    registration
  }
})
